// extracted by mini-css-extract-plugin
export default {"reprovisioning":"ReProvisionSalesforcePage_reprovisioning__Ddvq8","wrapper":"ReProvisionSalesforcePage_wrapper__psjkR","body":"ReProvisionSalesforcePage_body__hS4zj"};